



















import Vue from 'vue'
export default Vue.extend({
  name: 'DashboardGridListToggle',

  props: {
    viewType: {
      type: String,
      default: 'grid',
    },
  },

  computed: {
    isGridActive(): boolean {
      return this.viewType === 'grid'
    },
    internalViewType: {
      get(): any {
        return this.viewType
      },
      set(newValue: any) {
        this.$emit('update:viewType', newValue)
      },
    },
  },

  methods: {
    changeActive(type: string) {
      this.internalViewType = type
    },
  },
})
